var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v("Something went wrong")]),_c('div',{staticClass:"body"},[_vm._v("The exporting process failed, please try to download the package again.")])])
}]

export { render, staticRenderFns }